import { render, staticRenderFns } from "./PriceRuleEditList.vue?vue&type=template&id=478d151f"
import script from "./PriceRuleEditList.vue?vue&type=script&lang=ts"
export * from "./PriceRuleEditList.vue?vue&type=script&lang=ts"
import style0 from "./PriceRuleEditList.vue?vue&type=style&index=0&id=478d151f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports